import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsSupportWebsitePagesRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-support-website-details-pages',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/pages',
	exact: true,
};
